var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"app-button app-file-input"},[_c('input',{attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.uploadFile}}),(!_vm.isLoading)?_c('div',{staticClass:"button"},[_vm._t("default")],2):_c('line-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }